import React from "react";
import CriticalIllnessTabImage from "../../Assets/Images/Critical-b.png";
import CheckIcon from "../../Assets/Images/check-white-icon.svg";
import { useTranslation } from "../../Hooks/useTranslation"; // Import translation hook

const CoveredFull = () => {
  const translations = useTranslation(); // Get translations dynamically

  return (
    <>
      <div className="flex flex-col lg:mt-[5rem] mt-[2rem]">
        <div className="-mr-4 md:mr-0 md:pl-4 lg:hidden flex md:max-w-[664px] overflow-hidden md:overflow-visible mb-10 reveal-up">
          <img
            src={CriticalIllnessTabImage}
            alt="Critical-b"
            className="w-[130%] md:w-full max-w-none h-auto"
          />
        </div>
        <div className="mb-4 lg:max-w-[450px] [@media(min-width:1920px)]:!max-w-[680px] [@media(min-width:1920px)]:!min-h-[450px] md:px-0 px-4 cover100-content">
          <p className="md:text-[12px] xl:text-[16px] text-[14px] md:leading-[17px] xl:leading-[22px] [@media(min-width:1920px)]:!text-[24px] [@media(min-width:1920px)]:!leading-[33px] [@media(min-width:1920px)]:!tracking-[-0.48px] mb-3 [@media(min-width:1920px)]:!mb-11 extra-para-vs reveal-up reveal-delay-1">
            {translations.coveredFull.description}
          </p>
          <div className="flex mt-6 [@media(min-width:1920px)]:!gap-9">
            <div className="md:w-2/3 w-3/5 [@media(min-width:1920px)]:!w-1/2 reveal-up reveal-delay-2">
              <ul className="md:text-[12px] xl:text-[16px] text-[14px] [@media(min-width:1920px)]:!text-[24px]">
                {Object.entries(translations.coveredFull.diseases)
                  .slice(0, 6) // First column
                  .map(([key, value]) => (
                    <li key={key} className="flex items-center mb-4 [@media(min-width:1920px)]:!mb-6 extra-para-vs">
                      <div className="flex items-center justify-center w-4 h-4 min-w-[16px] min-h-[16px] [@media(min-width:1920px)]:!w-6 [@media(min-width:1920px)]:!h-6 [@media(min-width:1920px)]:!min-w-[24px] [@media(min-width:1920px)]:!min-h-[24px] bg-[#53BCC8] rounded-full covered-col-circle">
                        <img
                          src={CheckIcon}
                          alt="Check Icon"
                          className="w-[10px] h-[10px] [@media(min-width:1920px)]:!w-[14px] [@media(min-width:1920px)]:!h-[14px]"
                        />
                      </div>
                      <span className="ml-1.5 [@media(min-width:1920px)]:!ml-[9px] [@media(min-width:1920px)]:!leading-[33px]">{value}</span>
                    </li>
                  ))}
              </ul>
            </div>
            <div className="md:w-1/3 w-2/5 [@media(min-width:1920px)]:!w-1/2 reveal-up reveal-delay-3">
              <ul className="md:text-[12px] xl:text-[16px] text-[14px] [@media(min-width:1920px)]:!text-[24px]">
                {Object.entries(translations.coveredFull.diseases)
                  .slice(6) // Second column
                  .map(([key, value]) => (
                    <li key={key} className="flex items-center mb-4 [@media(min-width:1920px)]:!mb-6 extra-para-vs">
                      <div className="flex items-center justify-center w-4 h-4 min-w-[16px] min-h-[16px] [@media(min-width:1920px)]:!w-6 [@media(min-width:1920px)]:!h-6 [@media(min-width:1920px)]:!min-w-[24px] [@media(min-width:1920px)]:!min-h-[24px] bg-[#53BCC8] rounded-full covered-col-circle">
                        <img
                          src={CheckIcon}
                          alt="Check Icon"
                          className="w-[10px] h-[10px] [@media(min-width:1920px)]:!w-[14px] [@media(min-width:1920px)]:!h-[14px]"
                        />
                      </div>
                      <span className="ml-1.5 [@media(min-width:1920px)]:!ml-[9px] [@media(min-width:1920px)]:!leading-[33px]">{value}</span>
                    </li>
                  ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CoveredFull;
